import styles from "./index.module.scss"
import eventBus from "@utils/eventBus";
import InviteUserModal from '@view/compoents/inviteUserModal/inviteUserModal'
import { useContext, useMemo, useEffect } from "react";
import { AppContext } from '@utils/AppContext';
import Utils from '@utils/utils';
import { HOME_PAGE_TYPE } from "@utils/CONST"
import { useNavigate } from "react-router";
import Iconfont from '@utils/Iconfont';
import dayjs from 'dayjs';

function MembershipBtn(props) {
    const { globalOrgInfo } = useContext(AppContext);
    return <>
        {
            globalOrgInfo?.current?.role == 'member' ? null :
                <div className={styles.MembershipBtn} onClick={props.onClick}>
                    <Iconfont type="icon-CrownFilled" />
                    <span>会员低至0.16元/图</span>
                </div>
        }
    </>
}

function NewUserBtn(props) {
    const navigate = useNavigate();

    const handleClick = () => {
        eventBus.emit('login', {
            callback: logged => {
                if (logged) {
                    Utils.useroplog(HOME_PAGE_TYPE.CLOTHING, 'function', 'navigation', { from: 'home' })
                    Utils.clearAllTaskCache()
                    navigate("/home/homemain/clothes")
                }
                else console.log('取消了登录')
            }
        })
    }

    return <>
        <div className={styles.NewUserBtn} onClick={handleClick}>
            <Iconfont type="icon-GiftFilled" />
            <span>新人免费作图40张</span>
        </div>
    </>
}

function InviteBtn(props) {
    const { globalUser, globalActivity } = useContext(AppContext);

    // 活动期间要显示活动弹窗
    const ACTIVITY_240711_DISPALY = useMemo(() => {
        if (!globalActivity) return false
        const activity = globalActivity.ACTIVITY_240711
        const now = dayjs()
        const start = dayjs(activity.beginAt)
        return !(now.isBefore(start) || now.isAfter(activity.endAt.add(0, 'day')))
    })

    return <>
        <div className={styles.InviteBtn} onClick={() => ACTIVITY_240711_DISPALY ? eventBus.emit('OPEN_INVITATION_EVENT') : eventBus.emit('inviteUser')}>
            {ACTIVITY_240711_DISPALY ? <Iconfont type="icon-ranking" /> : <Iconfont type="icon-GiftFilled" />}
            <span>{ACTIVITY_240711_DISPALY ? '邀新天梯赛' : '邀请有礼'}</span>
        </div>
        <InviteUserModal invitationCode={globalUser?.invitationCode} />
    </>
}

function ServiceBtn(props) {
    const navigate = useNavigate()
    const handleClick = () => {
        navigate("/service")
    }
    return (
        <div className={styles.ServiceBtn} onClick={handleClick}>
            <Iconfont type="icon-aiEdit" />
            <span>AI服务助手</span>
            <img style={{ display: 'none' }} src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/InvitationModalBg.png" alt="" /> {/* 预加载活动弹窗背景图 */}
        </div>
    )
}

export {
    MembershipBtn,
    NewUserBtn,
    InviteBtn,
    ServiceBtn
}